<template>
  <b-card shadow-sm class="mb-4">
    <h5 :class="['mb-3', titleClass]">{{ title }}</h5>
    <div v-for="vehicle in items" :key="type + '-' + vehicle.regNo" class="vehicle-mini-item d-flex align-items-center mb-3">
      <div 
        :class="['vehicle-avatar mr-3', avatarClass]" 
        style="cursor: pointer" 
        v-b-tooltip.hover title="View Technical Details"
        @click.stop="$emit('open-master-details', vehicle)"
      >
        <md-icon>{{ icon }}</md-icon>
      </div>
      <div class="flex-grow-1">
        <div class="d-flex justify-content-between">
          <a href="javascript:void(0)" @click="$emit('select-vehicle', vehicle.regNo)" class="font-weight-bold text-primary vehicle-link">
            {{ vehicle.regNo }}
          </a>
          <span :class="['small font-weight-bold', textClass]">
            {{ type === 'most-used' ? `${vehicle.trips} Trips | ${vehicle.performance}%` : `Idle ${vehicle.idleDays} Days` }}
          </span>
        </div>
        <b-progress v-if="type === 'most-used'" :value="vehicle.performance" variant="primary" height="6px" class="mt-1"></b-progress>
        <div v-else class="text-muted xs-font">
          Last active: {{ vehicle.lastActive }}
          <div v-if="vehicle.grnNo || vehicle.assignmentNo" class="mt-1">
            <b-badge v-if="vehicle.grnNo" variant="light" class="mr-1 text-dark border">GRN: {{ vehicle.grnNo }}</b-badge>
            <b-badge v-if="vehicle.assignmentNo" variant="light" class="text-dark border">ASG: {{ vehicle.assignmentNo }}</b-badge>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-3">
      <b-button variant="link" class="p-0 small" @click="$emit('view-all')">
        {{ type === 'idle' ? 'View All Idle' : 'View Full Ranking' }}
      </b-button>
      <b-button v-if="type === 'idle'" variant="outline-danger" size="sm" pill>
        Alert Fleet Manager
      </b-button>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'VehicleMiniList',
  props: {
    title: { type: String, required: true },
    items: { type: Array, required: true },
    type: { type: String, default: 'most-used' } // 'most-used' or 'idle'
  },
  computed: {
    titleClass() { return this.type === 'idle' ? 'text-danger' : ''; },
    avatarClass() { return this.type === 'idle' ? 'bg-light-danger' : 'bg-light-primary'; },
    textClass() { return this.type === 'idle' ? 'text-danger' : 'text-primary'; },
    icon() { return this.type === 'most-used' ? 'trending_up' : 'history_toggle_off'; }
  }
};
</script>

<style scoped>
.vehicle-mini-item {
  padding: 10px;
  background: white;
  border-radius: 8px;
  transition: background 0.2s;
}
.vehicle-mini-item:hover {
  background: #f1f3f5;
}
.vehicle-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-light-primary { background-color: #e9ecef !important; color: #3b82f6 !important; }
.bg-light-danger { background-color: #fee2e2 !important; color: #ef4444 !important; }
.vehicle-link {
  text-decoration: none;
  cursor: pointer;
}
.vehicle-link:hover {
  text-decoration: underline !important;
}
.xs-font {
  font-size: 0.65rem;
  letter-spacing: 0.08em;
}
</style>



// WEBPACK FOOTER //
// VehicleMiniList.vue?2c88f470